import { Fragment } from 'react';

/** One row of the legend: the token as it appears on the line, and what it means. */
const TOKENS: { token: string; meaning: string }[] = [
  { token: 'F  ·  X', meaning: 'Follow · Withdraw' },
  { token: 'C  ·  P', meaning: 'Connect · Call' },
  { token: 'M1 · R1', meaning: 'Message · Reminder' },
  { token: 'I1 · E1', meaning: 'InMail · Email' },
  { token: 'L · L3', meaning: 'Like — one post · 3 posts' },
  { token: 'W3 · W2w', meaning: 'Wait — 3 days · 2 weeks' },
  { token: 'A · A7', meaning: 'Await connect — default 5-day deadline · 7-day' },
  { token: 'A{ … }', meaning: '{ } after an await is the not-accepted arm' },
  { token: '( … , … )', meaning: 'Parallel — every arm must finish before the line moves on' },
  { token: '[ … ]', meaning: 'Spawn — a detached arm running alongside the main line' },
  { token: '?AUM{ … }', meaning: 'Switch — route by AUM (or ?AGE); * is the catch-all branch' },
];

/**
 * Tooltip body for {@link SequenceTextStrip} — the notation, one token per row, so the line underneath is
 * readable without opening `sequenceText.ts`. Lists only what a builder can actually put on the canvas, in
 * the forms `serialize` actually EMITS: it drops defaults, so an await with the standard 5-day deadline is
 * a bare `A` and a single-post like is a bare `L` — teaching `A5` / `L1` would document output nobody sees.
 *
 * Spans (not divs / a `<dl>`) because this renders inside the tooltip's `<span popover role="tooltip">`, and
 * muted text is `opacity`, not a gray: the gray tooltip INVERTS between themes (dark slab in light mode, light
 * slab in dark), so any fixed text color is unreadable in one of them.
 */
export function SequenceTextLegend() {
  return (
    <span className="block space-y-2 py-0.5 text-left">
      <span className="block font-medium">The whole sequence on one line.</span>

      <span className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1">
        {TOKENS.map(({ token, meaning }) => (
          <Fragment key={token}>
            <span className="whitespace-nowrap font-mono">{token}</span>
            <span className="opacity-70">{meaning}</span>
          </Fragment>
        ))}
      </span>

      <span className="block opacity-70">
        A numbered label (M1, E2 …) marks a step whose written content lives off the line — that is what keeps the
        shape scannable.
      </span>
    </span>
  );
}
